const Image = ({ url, alt = 'coach' }) => {
  return (
    <div className="w-full flex justify-center items-center">
      <img src={url} alt={alt} className="w-75 h-75 object-cover rounded" />
    </div>
  );
};

export default Image;
